module.exports = __webpack_public_path__ + "static/illustration-a4a302b77cb988efa8e19161ed8be730.png";